import styled from "@emotion/styled";
import * as React from "react";

import { ActionLink } from "components/links/ActionLink";
import { StyledLink } from "components/links/StyledLink";
import { isInIframe } from "helpers/app";
import { getAppRootWithOrigin } from "helpers/url";

export enum Reason {
  NoResponses,
  NoFilteredResults,
}

interface IProps {
  reason: Reason;
}

const Wrapper = styled.div`
  padding: 10px;
  font-size: 15px;
  line-height: 1.3;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor80
  };
`;

const url = "/settings/canned-responses";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const openExternalLink = () => {
  window.open(`${getAppRootWithOrigin()}${url}`);
};
const CannedResponsesEmptyNoResponses: React.FC = () => {
  const showExternalAppLink = isInIframe();
  return (
    <Wrapper>
      No canned responses.
      <br />
      {showExternalAppLink ? (
        <ActionLink onClick={openExternalLink}>Create new</ActionLink>
      ) : (
        <StyledLink to={url}>Create new</StyledLink>
      )}
    </Wrapper>
  );
};

const CannedResponsesEmptyNoFilteredResults: React.FC = () => <Wrapper>No such canned response.</Wrapper>;

export const CannedResponsesEmpty: React.FC<IProps> = ({ reason }) =>
  reason === Reason.NoResponses ? <CannedResponsesEmptyNoResponses /> : <CannedResponsesEmptyNoFilteredResults />;
